import React, { useState, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Razorpay from './Razorpay';
import Paypal from './Paypal';
import Stripe from './Stripe';
import MercadoPago from './MercadoPago';
import PayFast from './PayFast';
import { MyContext } from '../Context/MyProvider';
import axios from 'axios';
import { showToast } from '../showTost';
import secureLocalStorage from 'react-secure-storage';
import Midtrans from './Midtrans';
import KhaltiPayment from './KhaltiPayment';

const Payment = ({ totalpay, BookingData, isshow, PageIndex }) => {
    const { t } = useTranslation();
    const { BaseUrl, paymentloading, setPaymentRes, paymentRes, setPaymentLoading } = useContext(MyContext);

    const [apiloading, setApiLoading] = useState(false);
    const [attributes, setAttributes] = useState("");
    const [istrue, setIsTrue] = useState(false);
    const [paymentlist, setPaymentList] = useState([]);
    const [selectpayment, setSelectPayment] = useState("");
    const [isDriverSelected, setIsDriverSelected] = useState(false);
    const [myWallet, setMyWallet] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);
    const [usedWallet, setUsedWallet] = useState(0);

    const Currency = secureLocalStorage.getItem("currency");

    useEffect(() => {
        setTotalAmount(totalpay);
        handleGetPaymentGateway();
        setMyWallet(secureLocalStorage.getItem("wallet"));
    }, []);

    useEffect(() => {
        if (!paymentRes) return;
        if (paymentRes !== "PaymentDone") {
            setSelectPayment("");
            setIsTrue(false);
        }
    }, [paymentRes]);

    useEffect(() => {
        if (isDriverSelected) {
            setSelectPayment("");
            if (totalAmount > myWallet) {
                const Total = totalAmount - myWallet;
                setTotalAmount(Total);
                setMyWallet(0);
                setUsedWallet(myWallet);
            } else {
                const Total = myWallet - totalAmount;
                setMyWallet(Total);
                setUsedWallet(totalAmount);
                setTotalAmount(0);
            }
        } else {
            setMyWallet(secureLocalStorage.getItem("wallet"));
            setTotalAmount(totalpay);
            setUsedWallet(0);
        }
    }, [isDriverSelected])

    const handleGetPaymentGateway = () => {
        setApiLoading(true);
        axios.get(`${BaseUrl}tcapi/s_paymentgateway.php`)
            .then((res) => {
                // console.log("s_paymentgateway.php", res.data.data);
                setPaymentList(res.data.data);
                setApiLoading(false);
            })
            .catch((error) => {
                console.error("s_paymentgateway.php", error);
            });
    }

    const handleSelectPayment = (item) => {
        if (PageIndex == "2" && totalAmount == 0) return;
        setSelectPayment(item.id);
        setAttributes(item.attributes)
    }

    const handleContinue = () => {

        if (PageIndex == "2" && totalAmount == 0) {
            const Data = {
                ...BookingData,
                p_method_id: "5",
                extra_wall_amt: usedWallet
            }
            secureLocalStorage.setItem("Bookingdata", JSON.stringify(Data));
            sessionStorage.setItem("transactionid", "0");
            setPaymentRes("PaymentDone");
            return;
        }

        if (PageIndex == "1" && !totalAmount) {
            showToast({ title: t("Please enter amount !!"), id: "info" });
            return;
        }

        if (totalAmount !== 0 && !selectpayment) {
            showToast({ title: t("Please select payment method !!"), id: "info" });
            return;
        }

        if (BookingData) {
            let Data;

            if (PageIndex == "2") {
                Data = {
                    ...BookingData,
                    p_method_id: selectpayment,
                    extra_wall_amt: usedWallet
                }
            } else {
                Data = {
                    ...BookingData,
                    p_method_id: selectpayment
                }
            }

            secureLocalStorage.setItem("Bookingdata", JSON.stringify(Data));
        }

        if (PageIndex == "1") {
            secureLocalStorage.setItem("amount", totalAmount);
        }

        if (selectpayment === "2") {
            sessionStorage.setItem("transactionid", "0");
            setPaymentRes("PaymentDone");
        } else {
            setIsTrue(true);
        }
        setPaymentLoading(true);
    }

    return (
        <div className="payment_page">


            {PageIndex == "1" && <div className="px-[20px] pt-[10px]">
                <h1 className="font-[500] text-[18px] text-gray-600">{t("Add Amount")}</h1>
                <input type="number" value={totalAmount} onChange={(e) => setTotalAmount(e.target.value)} className="w-full border-[2px] px-[15px] py-[5px] rounded-[10px]" placeholder="Enter Amount" />
            </div>}

            {(PageIndex == "2" && secureLocalStorage.getItem("wallet") !== 0) && <div className="mx-[20px] border-[1px] border-gray-300 rounded-[10px] py-[10px] px-[20px] mt-[20px]">
                <div className="flex items-center justify-between mb-[10px]">
                    <h1 className='font-[500] text-[17px]'>{t("Pay from Wallet")}</h1>
                    <label className="switch">
                        <input type="checkbox" checked={isDriverSelected} onChange={() => setIsDriverSelected(!isDriverSelected)} />
                        <span className="slider round"></span>
                    </label>
                </div>
                <div className="border-[1px] border-[#8080803b] p-[10px] rounded-[10px] flex items-center justify-between">
                    <div className="flex items-center gap-[5px]">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.75 6.297V6C18.75 3.582 17.418 2.25 15 2.25H5C3.483 2.25 2.25 3.483 2.25 5V18C2.25 20.418 3.582 21.75 6 21.75H18C20.418 21.75 21.75 20.418 21.75 18V10C21.75 7.845 20.692 6.553 18.75 6.297ZM20.25 15.75H16.5C15.535 15.75 14.75 14.965 14.75 14C14.75 13.035 15.535 12.25 16.5 12.25H20.25V15.75ZM5 3.75H15C16.577 3.75 17.25 4.423 17.25 6V6.25H5C4.311 6.25 3.75 5.689 3.75 5C3.75 4.311 4.311 3.75 5 3.75ZM18 20.25H6C4.423 20.25 3.75 19.577 3.75 18V7.44897C4.125 7.64097 4.55 7.75 5 7.75H18C19.577 7.75 20.25 8.423 20.25 10V10.75H16.5C14.708 10.75 13.25 12.208 13.25 14C13.25 15.792 14.708 17.25 16.5 17.25H20.25V18C20.25 19.577 19.577 20.25 18 20.25ZM17.01 13H17.02C17.573 13 18.02 13.448 18.02 14C18.02 14.552 17.573 15 17.02 15C16.468 15 16.015 14.552 16.015 14C16.015 13.448 16.458 13 17.01 13Z" fill="#25314C" />
                        </svg>
                        <h1 className='font-[500] text-[16px]'>{t("My Wallet")}</h1>
                    </div>
                    <h1 className='font-[500] text-[17px] text-[#682afb]'>{Currency}{myWallet}</h1>
                </div>
            </div>}

            <h1 className="font-[500] text-[18px] px-[20px] pt-[10px] text-gray-600">{t("Select Payment Method")}</h1>
            <div className="h-[400px] px-[20px] scroll_container">
                {apiloading
                    ? <div className="h-full flex items-center justify-center">
                        <div className="loader mx-auto"></div>
                    </div>
                    : paymentlist?.map((item, index) => {
                        const isSelect = item.id === selectpayment;
                        if (item.id !== isshow) {
                            return <div key={index} onClick={() => handleSelectPayment(item)} className={`payment_box border-[2px] ${PageIndex == "2" && totalAmount == 0 ? "bg-gray-200 cursor-not-allowed" : "bg-white cursor-pointer"} ${isSelect ? "border-[--bgcolor]" : ""}`}>
                                <div className="flex items-center gap-[10px]">
                                    <img src={BaseUrl + item.img} className="w-[65px] max-h-[65px] border-[2px] rounded-[20px]" alt="img" />
                                    <div className="">
                                        <h1 className="font-[500] text-[17px]">{item.title}</h1>
                                        <p className="text-[15px] text-gray-600 font-[500] leading-[18px]">{item.subtitle}</p>
                                    </div>
                                </div>
                                {totalAmount !== "0" && <div className="w-[30px]">
                                    <div className={`w-[18px] h-[18px] rounded-full border-[2px] p-[2px] duration-[.5s] ${isSelect ? "border-[--bgcolor]" : ""}`}>
                                        <div className={`w-full h-full rounded-full duration-[.5s] ${isSelect ? "bg-[--bgcolor]" : "bg-transparent"}`}></div>
                                    </div>
                                </div>}
                            </div>
                        }
                    })}
            </div>

            <div className=" bg-white py-[10px] px-[20px]">
                <button onClick={handleContinue} className="w-full text-white rounded-[5px] font-bold text-[17px] bg-[--bgcolor] py-[10px] hover:shadow-[0,5px,8px,rgba(2,6,12,.2)]">
                    {paymentloading
                        ? <div className="btn_loader mx-auto"></div>
                        : <span>{t("CONTINUE")}</span>}
                </button>
            </div>

            {(selectpayment === "1" && istrue) && <Razorpay Amount={totalAmount} attributes={attributes} />}
            {(selectpayment === "3" && istrue) && <div onClick={() => { setSelectPayment(""); setIsTrue(false) }} className=" px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
                <div onClick={(e) => e.stopPropagation()} className="w-[20%]  max-_430_:w-[100%] max-_768_:w-[90%] max-_1030_:w-[50%] max-_1500_:w-[40%] bg-white rounded-[15px] p-[15px]">
                    <div className="flex flex-col justify-center items-center text-center">
                        <Paypal Amount={totalAmount} attributes={attributes} />
                    </div>
                </div>
            </div>}
            {(selectpayment === "4" && istrue) && <div onClick={() => { setSelectPayment(""); setIsTrue(false) }} className=" px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
                <div onClick={(e) => e.stopPropagation()} className="w-[20%]  max-_430_:w-[100%] max-_768_:w-[90%] max-_1030_:w-[50%] max-_1500_:w-[40%] bg-white rounded-[15px] p-[15px]">
                    <div className="flex flex-col justify-center items-center text-center">
                        <Stripe Amount={totalAmount} />
                    </div>
                </div>
            </div>}
            {(selectpayment === "11" && istrue) && <MercadoPago Amount={totalAmount} />}
            {(selectpayment === "12" && istrue) && <PayFast Amount={totalAmount} attributes={attributes} />}
            {(selectpayment === "13" && istrue) && <Midtrans Amount={totalAmount} />}
            {(selectpayment === "15" && istrue) && <KhaltiPayment Amount={totalAmount} />}


        </div>
    )
}

export default Payment;